var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-bb964d78-7e68-4e79-8bff-7bd42590902d",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-de6f194f-fcf0-407e-8093-da704a57c506 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-de6f194f-fcf0-407e-8093-da704a57c506",
    d: "M18.94,22.96h-5.88c-1.16,0-2.1-.94-2.1-2.1v-9.72c0-1.16.94-2.1,2.1-2.1h4.57l3.41,3.21v8.61c0,1.16-.94,2.1-2.1,2.1ZM13.06,11.04c-.06,0-.1.05-.1.1v9.72c0,.06.05.1.1.1h5.88c.06,0,.1-.05.1-.1v-7.75l-2.21-2.08h-3.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.01aac4414d46fed57d564230d97138b0.svg";
export { ForwardRef as ReactComponent };